export default __webpack_public_path__ + "static/media/review1.e82bd3ca.webp";